import { useEffect, useState, useCallback } from 'react';

// import axios from 'axios';
import useSiteMetadata from './use-site-metadata';
import isBrowser from '../utils/isBrowser';

const GRECAPTCHA_SRC = 'https://www.google.com/recaptcha/api.js';
// const GRECAPTCHA_VERIFY = 'https://www.google.com/recaptcha/api/siteverify';

const useRecaptcha = () => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const { grecaptchaSiteKey } = useSiteMetadata();
  const setReady = useCallback(() => {
    if (isBrowser()) {
      window.grecaptcha?.ready(() => setHasLoaded(true));
    }
  }, []);

  useEffect(() => {
    let recaptchaScript: HTMLScriptElement | undefined = undefined;
    if (isBrowser()) {
      const currentScript = document.querySelector(`script[src="${grecaptchaSiteKey}"]`);
      if (currentScript) {
        setReady();
      }

      recaptchaScript = document.createElement('script');
      recaptchaScript.src = `${GRECAPTCHA_SRC}?render=${grecaptchaSiteKey}`;
      recaptchaScript.async = true;
      recaptchaScript.defer = true;
      recaptchaScript.addEventListener('load', setReady);
      document.getElementsByTagName('head')[0].appendChild(recaptchaScript);
    }

    return () => {
      if (isBrowser()) {
        recaptchaScript?.removeEventListener('load', setReady);
      }
    };
  }, [grecaptchaSiteKey, setReady]);

  const getToken = async () => {
    try {
      if (isBrowser()) {
        const token = await window.grecaptcha?.execute(grecaptchaSiteKey, {
          action: 'submit',
        });

        return token;
      }
    } catch (error) {
      console.error(`useRecaptcha (getToken): ${error}`);
    }
  };

  // const verifySubmission = async (token?: string) => {
  //   try {
  //     if (!token) return;

  //     const verifySite = await axios({
  //       method: 'POST',
  //       url: GRECAPTCHA_VERIFY,
  //       params: {
  //         // TODO: find best way to get this key from secrets.json
  //         secret: 'secrets.grecaptcha.secret_key',
  //         response: token
  //       }
  //     });

  //     return verifySite;
  //   } catch (error) {
  //     console.error(`useRecaptcha (verifySubmission): ${error}`);
  //   }
  // };

  return { hasLoaded, getToken };
};

export default useRecaptcha;
